import { render, staticRenderFns } from "./TipoValorForm.vue?vue&type=template&id=48654cf8"
import script from "./TipoValorForm.vue?vue&type=script&lang=js"
export * from "./TipoValorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports